// Front-end entry (built to theme/dist/frontend.min.js): only the helpers that saved block
// markup and the StarfrontTravel theme call on the live site. Kept free of wp.* / React so pages
// don't load the editor stack; blocks.min.js (block registration) is enqueued in admin only.
// Importing front.js also runs its hydrateCategoryList observer (rbt/allcategorylist).
import { Loader, accordionClick, mosViewMore, saveStudent } from './front.js';
import { tabMenuScroll, doTabMenuClick, setTabPanels } from './components/tabpanels-tabs.js';

window.Loader = Loader;
window.accordionClick = accordionClick;
window.mosViewMore = mosViewMore;
window.saveStudent = saveStudent;
window.tabMenuScroll = tabMenuScroll;
window.doTabMenuClick = doTabMenuClick;
window.setTabPanels = setTabPanels;

// Back/forward: re-open the tab named in the #/tab/ hash (or the first tab when the hash is gone) without pushing a new entry.
window.addEventListener("popstate", () => {
    const match = window.location.hash.match(/^#\/tab\/(.+)$/);
    const li = match
        ? document.getElementById("ctrl-" + decodeURIComponent(match[1]))
        : document.querySelector(".rbt-tabpanels .nav-tab[data-tab-trigger]");
    if (li) doTabMenuClick({ target: li, preventDefault() {} }, true);
});

// Run now if the DOM is already parsed: script loaders (e.g. a consent autoblocker) can
// execute this after DOMContentLoaded has fired, and the listener would then never run.
if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", setTabPanels);
} else {
    setTabPanels();
}
